import BackendService from './BackendService';

export default class FontService {
  static createFont(file) {
    const formData = new FormData();
    formData.append('file', file);
    return BackendService.post(
      '/fonts',
      {
        formData,
      },
      true,
    );
  }

  static getAvailableFonts() {
    return BackendService.get(`/fonts/all`);
  }
}
